import {
  Box,
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import ElectricPlantForm from "./PDF/electricPlant/electricPlantForm";
import { useTranslation } from "react-i18next";
import MaintenanceCorrectivePDF from "./PDF/MaintenanceCorrectivePDF";

export const ChecklistSection = ({
  selectedSchedule,
  currentUser,
  localNotes,
  handleChecklistItemChange,
  handleLocalNotesChange,
  handleSaveNotes,
  scheduleData,
  technicianSignature,
}) => {
  const { t } = useTranslation();

  const filteredQuestions = selectedSchedule?.checklist_questions
    ?.filter(
      (question) => question.service_type === selectedSchedule.service_type
    )
    ?.sort((a, b) => {
      if (a.question.toLowerCase() === "observaciones") return 1;
      if (b.question.toLowerCase() === "observaciones") return -1;
      return a.order - b.order;
    });

  const handleSaveAllNotes = () => {
    Object.keys(localNotes).forEach((questionId) => {
      handleSaveNotes(parseInt(questionId));
    });
  };

  const renderNotesInput = (question, checklist) => {
    if (
      selectedSchedule.service_type === "preventivo" ||
      selectedSchedule.service_type === "escalator"
    ) {
      if (question.question === "observaciones") {
        return (
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder={t("addNotesPlaceholder")}
            value={localNotes[question.id] ?? checklist?.notes ?? ""}
            disabled={
              (selectedSchedule?.status === "completed" &&
                currentUser !== "admin") ||
              (currentUser !== "admin" && !selectedSchedule.service_started_at)
            }
            onChange={(e) =>
              handleLocalNotesChange(question.id, e.target.value)
            }
          />
        );
      }
      return (
        <div className="form-group">
          <label>{t("estado")}</label>
          <select
            value={localNotes[question.id] ?? checklist?.notes ?? ""}
            disabled={
              (selectedSchedule?.status === "completed" &&
                currentUser !== "admin") ||
              (currentUser !== "admin" && !selectedSchedule.service_started_at)
            }
            onChange={(e) =>
              handleLocalNotesChange(question.id, e.target.value)
            }
          >
            <option value="-">-</option>
            <option value="ok">OK</option>
          </select>
        </div>
      );
    }

    switch (question.input_type) {
      case "textarea":
        return (
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder={t("addNotesPlaceholder")}
            value={localNotes[question.id] ?? checklist?.notes ?? ""}
            disabled={
              (selectedSchedule?.status === "completed" &&
                currentUser !== "admin") ||
              (currentUser !== "admin" && !selectedSchedule.service_started_at)
            }
            onChange={(e) =>
              handleLocalNotesChange(question.id, e.target.value)
            }
          />
        );
      case "number":
        return (
          <TextField
            type="number"
            fullWidth
            placeholder={t("enterValuePlaceholder")}
            value={localNotes[question.id] ?? checklist?.notes ?? ""}
            disabled={
              (selectedSchedule?.status === "completed" &&
                currentUser !== "admin") ||
              (currentUser !== "admin" && !selectedSchedule.service_started_at)
            }
            onChange={(e) =>
              handleLocalNotesChange(question.id, e.target.value)
            }
          />
        );
      default:
        return (
          <TextField
            fullWidth
            placeholder={t("addNotesPlaceholder")}
            value={localNotes[question.id] ?? checklist?.notes ?? ""}
            disabled={
              (selectedSchedule?.status === "completed" &&
                currentUser !== "admin") ||
              (currentUser !== "admin" && !selectedSchedule.service_started_at)
            }
            onChange={(e) =>
              handleLocalNotesChange(question.id, e.target.value)
            }
          />
        );
    }
  };

  const groupedQuestions = filteredQuestions?.reduce((groups, question) => {
    const group = question.grupo || "default";
    if (!groups[group]) {
      groups[group] = [];
    }
    groups[group].push(question);
    return groups;
  }, {});

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">{t("checklist")}</Typography>
      {selectedSchedule.service_type === "electric_plant" ? (
        <ElectricPlantForm
          questions={filteredQuestions}
          localNotes={localNotes}
          handleLocalNotesChange={handleLocalNotesChange}
          schedule_checklists={selectedSchedule.schedule_checklists}
        />
      ) : (
        <List>
          {Object.keys(groupedQuestions)?.map((group) => (
            <Box key={group} sx={{ mt: 2 }}>
              <Typography variant="h6">
                {t("group")} {group}
              </Typography>
              {groupedQuestions[group]?.map((question) => {
                const checklist = selectedSchedule.schedule_checklists?.find(
                  (cl) => cl.checklist_question_id === question.id
                );

                return (
                  <ListItem key={question.id}>
                    <ListItemText
                      primary={question.question}
                      secondary={renderNotesInput(question, checklist)}
                    />
                  </ListItem>
                );
              })}
            </Box>
          ))}
        </List>
      )}

      <Box sx={{ mt: 3, display: "flex", justifyContent: "center", gap: 2 }}>
        {selectedSchedule?.status !== "completed" && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveAllNotes}
            disabled={
              (selectedSchedule?.status === "completed" &&
                currentUser !== "admin") ||
              (currentUser !== "admin" && !selectedSchedule.service_started_at)
            }
          >
            {t("saveAllNotes")}
          </Button>
        )}
        <MaintenanceCorrectivePDF
          data={scheduleData}
          service_type={selectedSchedule.service_type}
        />
      </Box>
    </Box>
  );
};
